import './index.scss';
import React from 'react';
import { toast } from 'react-semantic-toasts';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Message } from 'semantic-ui/semantic-ui-imports';
import { getProject } from '../../services/projects';
import { Project } from '../../Types/Project';
import ResultList from '../../components/ResultList';

const classId = 'project-page';

const ProjectPage = () => {
  const { t } = useTranslation();

  const { projectId } = useParams<{ projectId: string }>();
  const [project, setProject] = React.useState<Project>();
  const [loading, setLoading] = React.useState<boolean>();

  const getObj = async () => {
    setLoading(true);
    try {
      const p = await getProject(projectId || '');
      if (p) {
        setProject(p);
      }
    } catch {
      toast({
        type: 'error',
        title: t('common.somethingWentWrong'),
        time: 4000,
        size: 'small',
      });
    }
    setLoading(false);
  };

  React.useEffect(() => {
    getObj();
  }, []);

  return (
    <div className={`${classId}`}>
      {!!project && <h2>{project.name}</h2>}
      {!loading && !project && (
        <>
          <Message info compact>
            <Message.Header>{t('project.noProject')}</Message.Header>
          </Message>
        </>
      )}
      {!!project && <h4>{t('project.resultsHeader')}</h4>}
      {project && (
        <ResultList projectId={project.id} initialResults={project.results} />
      )}
    </div>
  );
};

export default ProjectPage;
